import React from 'react';
import {FormattedMessage} from "react-intl";

import {sixteenGrey} from "assets/jss/main";

export default function CommentWillAppearMessage(props) {
    return (
        <span style={{ color: sixteenGrey}}>
            <FormattedMessage id={'picking.quote.history.comment.on.quote'} />
        </span>
    );
}
